import React from 'react';
import { dealLockHooks } from '../hooks';
import { BannerContainer } from '../common/Layout.style';
import RecalculateBanner from './recalculateBanner/RecalculateBanner.interstate';
import DroppedFeesBanner from './droppedFeesBanner/DroppedFeesBanner.interstate';
import AlertBanner from './components/AlertBanner.interstate';

interface BannerConfig {
    show: boolean;
    type: 'info' | 'success' | 'caution' | 'error';
    title: string;
    message: string;
    dataTestId: string;
    disableSuccessFade?: boolean;
    dismissButtonText?: string;
}

const Banner: React.FC = () => {
    const {
        isLocked,
        banner: { title, message }
    } = dealLockHooks.useDealFinalizationLocking();

    const alertBannerConfigs: BannerConfig[] = [
        {
            show: isLocked,
            type: 'success',
            title: title,
            message: message,
            dataTestId: 'deal-finalized-banner',
            disableSuccessFade: true
        }
    ];

    return (
        <BannerContainer>
            {alertBannerConfigs.map(
                (config, index) =>
                    config.show && (
                        <AlertBanner
                            key={`${config.dataTestId}-${index}`}
                            type={config.type}
                            title={config.title}
                            message={config.message}
                            dataTestId={config.dataTestId}
                            disableSuccessFade={config.disableSuccessFade}
                            dismissButtonText={config.dismissButtonText}
                        />
                    )
            )}
            <RecalculateBanner />
            <DroppedFeesBanner />
        </BannerContainer>
    );
};

export default Banner;
